export const isAdmin = (email: string): boolean => {
  return [
    'jose@leaf.swiss',
    'jeremy.gobet.72@gmail.com',
    'romain@leaf.swiss',
    'farhdine@leaf.swiss'
  ].includes(email);
};
